import React from "react";
import IntroBanner from "./children/introBanner/IntroBanner";
import styles from "./Home.module.scss";

function Home() {
  return (
    <div>
      <div id="home" className={styles.home}>
        <IntroBanner />
      </div>
    </div>
  );
}

export default Home;
